import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const RulesApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Rules" */ "./RulesApp");
    return { default: namedExport.RulesApp };
});

export const Rules: TeamAppConfig = {
    title: "Rules",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Rules App enables users to display, edit, and filter for IcM suppression, correlation, and routing rules.",
    team: "OSP",
    publicId: "ExchangeOSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: RulesApp,
    path: "/rules"
};
